import { createFileRoute } from '@tanstack/react-router';

import { StatusFlowPage } from '../../features/status-flow';

export const Route = createFileRoute('/_app/flow')({
  staticData: { crumbs: ['Статусы и процессы'] },
  component: StatusFlowPage,
});
